<script setup lang="ts">
    import { IDashboard } from '@/js/services/api/dashboard/types';
    import DashboardReportFooter from './DashboardReportFooter.vue';
    import Grid from '../grid/Grid.vue';
    import PageHeader from '../PageHeader.vue';
    import { __ } from '@/js/stores/expressions';
    import { ISharedDashboard } from '@/js/services/api/publicApi/types';

    interface Props {
        dashboard: IDashboard | ISharedDashboard;
    }

    const props = defineProps<Props>();

    const isSharedDashboard = (
        dashboard: IDashboard | ISharedDashboard
    ): dashboard is ISharedDashboard => {
        return (dashboard as ISharedDashboard).sharedByName !== undefined;
    };
</script>
<template>
    <div class="p-5 md:p-20">
        <PageHeader>
            <div>
                <h1 class="text-3xl">
                    {{ dashboard.title }}
                </h1>
                <p class="text-base font-normal">
                    {{ __('shared-dashboard-subtitle') }}
                </p>
            </div>
        </PageHeader>
        <div class="mt-2 bg-white rounded-lg shadow-md p-8">
            <Grid
                :dashboard-id="props.dashboard.id"
                :widget-data="props.dashboard.widgets"
                :widget-layout="props.dashboard.widgetLayout"
                :static-grid="true"
            />
        </div>
        <DashboardReportFooter
            v-if="
                isSharedDashboard(props.dashboard) &&
                props.dashboard.sharedByName &&
                props.dashboard.snapshotDate &&
                props.dashboard.expirationDate
            "
            :created-by="props.dashboard.sharedByName"
            :created-at="props.dashboard.snapshotDate"
            :expiration-date="props.dashboard.expirationDate"
        />
    </div>
</template>
